import { render, staticRenderFns } from "./color-checkerboard-bg.vue?vue&type=template&id=c2b6b94c"
import script from "./color-checkerboard-bg.vue?vue&type=script&lang=js"
export * from "./color-checkerboard-bg.vue?vue&type=script&lang=js"
import style0 from "./color-checkerboard-bg.vue?vue&type=style&index=0&id=c2b6b94c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports